var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from "react";
import { useContext, useEffect, useRef, useState } from "react";
import { CourseProgressProviderContext, CourseStatusProviderContext } from "../contexes/courseStatusProviderContext";
import { languageOptions } from "../utils/languages";
import { ToastContainer, toast } from "react-toastify";
import { getCompletion, getUserCourseData } from "../services/courseProgressService";
import "react-toastify/dist/ReactToastify.css";
var MessageType;

(function (MessageType) {
  MessageType["PROGRESS_UPDATED"] = "PROGRESS_UPDATED";
  MessageType["PEER_REVIEW_RECEIVED"] = "PEER_REVIEW_RECEIVED";
  MessageType["QUIZ_CONFIRMED"] = "QUIZ_CONFIRMED";
  MessageType["QUIZ_REJECTED"] = "QUIZ_REJECTED";
  MessageType["COURSE_CONFIRMED"] = "COURSE_CONFIRMED";
})(MessageType || (MessageType = {}));

var ConnectionStatus;

(function (ConnectionStatus) {
  ConnectionStatus["CONNECTED"] = "CONNECTED";
  ConnectionStatus["CONNECTING"] = "CONNECTING";
  ConnectionStatus["DISCONNECTED"] = "DISCONNECTED";
})(ConnectionStatus || (ConnectionStatus = {}));

var isMessage = function isMessage(message) {
  return "type" in message && message.type in MessageType;
};

export var CourseStatusProvider = React.memo(function (_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  var accessToken = props.accessToken,
      courseId = props.courseId,
      languageId = props.languageId;
  var prevProps = useRef({
    accessToken: "",
    courseId: "",
    languageId: ""
  });

  var _b = useState(true),
      loading = _b[0],
      setLoading = _b[1];

  var _c = useState(false),
      error = _c[0],
      setError = _c[1];

  var _d = useState({}),
      updateQuiz = _d[0],
      setUpdateQuiz = _d[1];

  var _e = useState(),
      data = _e[0],
      setData = _e[1];

  var _f = useState(ConnectionStatus.DISCONNECTED),
      moocfiStatus = _f[0],
      setMoocfiStatus = _f[1];

  var _g = useState(ConnectionStatus.DISCONNECTED),
      quizzesStatus = _g[0],
      setQuizzesStatus = _g[1];

  var _h = useState(),
      moocfiClient = _h[0],
      setMoocfiClient = _h[1];

  var _j = useState(),
      quizzesClient = _j[0],
      setQuizzesClient = _j[1];

  var shouldFetch = accessToken !== prevProps.current.accessToken || courseId !== prevProps.current.courseId || languageId !== prevProps.current.languageId;
  var shouldConnectMoocfi = !loading && !error && moocfiStatus === ConnectionStatus.DISCONNECTED;
  var shouldConnectQuizzes = !loading && !error && quizzesStatus === ConnectionStatus.DISCONNECTED;
  useEffect(function () {
    if (accessToken && courseId) {
      if (shouldFetch) {
        prevProps.current = props;
        fetchProgressData();
      }
    } else {
      logout();
    }
  });

  var fetchProgressData = function fetchProgressData() {
    return __awaiter(void 0, void 0, void 0, function () {
      var progressData, completionData, data_1, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);

            return [4, getUserCourseData(courseId, accessToken)];

          case 1:
            progressData = _a.sent();
            return [4, getCompletion(courseId, accessToken)];

          case 2:
            completionData = _a.sent();
            progressData.currentUser.completions = completionData.currentUser.completions;
            data_1 = transformData(progressData);
            setData(data_1);
            setLoading(false);
            return [3, 4];

          case 3:
            error_1 = _a.sent();
            setError(true);
            setLoading(false);
            console.log(error_1);
            console.log("Could not fetch course progress data");
            notifySticky(languageOptions[languageId].error.progressFetchError, "error");
            return [3, 4];

          case 4:
            return [2];
        }
      });
    });
  };

  var connect = function connect(host, setClient, setStatus) {
    return __awaiter(void 0, void 0, void 0, function () {
      var client, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setStatus(ConnectionStatus.CONNECTING);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4, new Promise(function (resolve, reject) {
              var client = new WebSocket(host, "echo-protocol");

              client.onopen = function () {
                resolve(client);
              };

              client.onerror = function (err) {
                reject(err);
              };
            })];

          case 2:
            client = _a.sent();
            client.onmessage = onMessage;

            client.onerror = function (e) {
              return reconnect(host, setStatus);
            };

            client.onclose = function (e) {
              return reconnect(host, setStatus);
            };

            client.send(JSON.stringify({
              accessToken: accessToken,
              courseId: courseId
            }));
            setClient(client);
            setStatus(ConnectionStatus.CONNECTED);
            console.log("connected to " + host);
            return [3, 4];

          case 3:
            error_2 = _a.sent();
            reconnect(host, setStatus);
            return [3, 4];

          case 4:
            return [2];
        }
      });
    });
  };

  var reconnect = function reconnect(host, setStatus) {
    console.log("could not connect to " + host + ", attempting to reconnect...");
    setTimeout(function () {
      return setStatus(ConnectionStatus.DISCONNECTED);
    }, 10000);
  };

  var logout = function logout() {
    setLoading(true);
    setError(false);
    setData(undefined);
    moocfiClient && moocfiClient.close();
    quizzesClient && quizzesClient.close();
    setMoocfiClient(undefined);
    setQuizzesClient(undefined);
    prevProps.current = {
      accessToken: "",
      courseId: "",
      languageId: ""
    };
  };

  var onMessage = function onMessage(inbound) {
    var _a, _b, _c;

    var message = JSON.parse(inbound.data);

    if (isMessage(message)) {
      switch (message.type) {
        case MessageType.PROGRESS_UPDATED:
          fetchProgressData();
          break;

        case MessageType.PEER_REVIEW_RECEIVED:
          setUpdateQuiz(__assign(__assign({}, updateQuiz), (_a = {}, _a[message.payload] = true, _a)));
          break;

        case MessageType.QUIZ_CONFIRMED:
          setUpdateQuiz(__assign(__assign({}, updateQuiz), (_b = {}, _b[message.payload] = true, _b)));
          break;

        case MessageType.QUIZ_REJECTED:
          setUpdateQuiz(__assign(__assign({}, updateQuiz), (_c = {}, _c[message.payload] = true, _c)));
          break;

        case MessageType.COURSE_CONFIRMED:
          fetchProgressData();
          break;
      }
    }
  };

  var notifyRegular = function notifyRegular(message, type) {
    return toast(message, {
      containerId: "regular",
      type: type
    });
  };

  var notifySticky = function notifySticky(message, type) {
    return toast(message, {
      containerId: "sticky",
      type: type
    });
  };

  var quizUpdated = function quizUpdated(id) {
    var _a;

    setUpdateQuiz(__assign(__assign({}, updateQuiz), (_a = {}, _a[id] = false, _a)));
  };

  var notifyError = function notifyError(message) {
    notifySticky(message, "error");
  };

  var progress = {
    error: error,
    loading: loading,
    courseProgressData: data
  };
  var status = {
    updateQuiz: updateQuiz,
    quizUpdated: quizUpdated
  };
  return React.createElement(CourseProgressProviderContext.Provider, {
    value: progress
  }, React.createElement(CourseStatusProviderContext.Provider, {
    value: status
  }, React.createElement(ToastContainer, {
    enableMultiContainer: true,
    newestOnTop: false,
    autoClose: false,
    hideProgressBar: true,
    containerId: "sticky",
    position: "top-left"
  }), React.createElement(ToastContainer, {
    enableMultiContainer: true,
    newestOnTop: false,
    hideProgressBar: true,
    containerId: "regular",
    position: "top-right"
  }), children));
});
export var injectCourseProgress = function injectCourseProgress(Component) {
  return function (props) {
    var injectProps = useContext(CourseProgressProviderContext);
    return React.createElement(Component, __assign({}, props, injectProps));
  };
};

var transformData = function transformData(data) {
  var courseProgress = data.currentUser.user_course_progresses[0];
  var completed = data.currentUser.completions.length > 0;
  var points_to_pass = 0;
  var n_points;
  var max_points;
  var exercise_completions = 0;
  var total_exercises = 0;
  var distinctActions = new Set();
  var progressByGroup = {};
  var exercise_completions_by_section;

  if (courseProgress) {
    n_points = courseProgress.n_points;
    max_points = courseProgress.max_points;
    exercise_completions_by_section = courseProgress.exercise_completions_by_section;

    for (var _i = 0, _a = courseProgress.progress; _i < _a.length; _i++) {
      var groupProgress = _a[_i];
      progressByGroup[groupProgress.group] = groupProgress;
    }
  }

  var required_actions = Array.from(distinctActions);
  return {
    completed: completed,
    points_to_pass: points_to_pass,
    n_points: n_points,
    max_points: max_points,
    exercise_completions: exercise_completions,
    total_exercises: total_exercises,
    required_actions: required_actions,
    progressByGroup: progressByGroup,
    exercise_completions_by_section: exercise_completions_by_section
  };
};